import { Component, OnInit, Input } from '@angular/core';
import {
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
} from '@angular/forms';
import { RouterService } from 'src/app/services/router/router.service';
import { ModalController } from '@ionic/angular';

import { AdressService } from 'src/app/services/address/adress.service';
import { TagsService } from 'src/app/services/tags/tags.service';
import { AlertController } from '@ionic/angular';
import { LanguagesService } from 'src/app/services/languagesService/languages.service';
import { StorageService } from 'src/app/services/storage/storage.service';
import {
  gluky_addressfield_cl_states_list,
  gluky_addressfield_cl_cities_list,
} from 'src/assets/utils/countryLocalities/cl-localities';
import {
  gluky_addressfield_mx_states_list,
  gluky_addressfield_mx_cities_list,
} from 'src/assets/utils/countryLocalities/mx-localities';
import {
  gluky_addressfield_per_states_list,
  gluky_addressfield_per_cities_list,
} from 'src/assets/utils/countryLocalities/per-localities';
import {
  gluky_addressfield_tt_states_list,
  gluky_addressfield_tt_cities_list,
} from 'src/assets/utils/countryLocalities/tt-localities';
import {
  gluky_addressfield_jm_states_list,
  gluky_addressfield_jm_cities_list,
} from 'src/assets/utils/countryLocalities/jm-localities';
import {
  gluky_addressfield_gy_states_list,
  gluky_addressfield_gy_cities_list,
} from 'src/assets/utils/countryLocalities/gy-localities';
import {
  gluky_addressfield_ar_states_list,
  gluky_addressfield_ar_cities_list,
} from 'src/assets/utils/countryLocalities/ar-localities';
import {
  gluky_addressfield_cu_states_list,
  gluky_addressfield_cu_cities_list,
} from 'src/assets/utils/countryLocalities/cu-localities';
import {
  gluky_addressfield_bb_states_list,
  gluky_addressfield_bb_cities_list,
} from 'src/assets/utils/countryLocalities/bb-localities';
import {
  gluky_addressfield_ky_states_list,
  gluky_addressfield_ky_cities_list,
} from 'src/assets/utils/countryLocalities/ky-localities';
import {
  gluky_addressfield_lc_states_list,
  gluky_addressfield_lc_cities_list,
} from 'src/assets/utils/countryLocalities/lc-localities';
import {
  gluky_addressfield_pr_states_list,
  gluky_addressfield_pr_cities_list,
} from 'src/assets/utils/countryLocalities/pr-localities';
import {
  gluky_addressfield_co_states_list,
  gluky_addressfield_co_cities_list,
  gluky_addressfield_co_localities_list,
} from 'src/assets/utils/countryLocalities/co-localities';
import {
  gluky_addressfield_ec_states_list,
  gluky_addressfield_ec_cities_list,
  gluky_addressfield_ec_localities_list,
} from 'src/assets/utils/countryLocalities/ec-localities';
import {
  gluky_addressfield_rd_states_list,
  gluky_addressfield_rd_cities_list,
  gluky_addressfield_rd_localities_list,
} from 'src/assets/utils/countryLocalities/rd-localities';
import {
  gluky_addressfield_hn_states_list,
  gluky_addressfield_hn_cities_list,
} from 'src/assets/utils/countryLocalities/hn-localities';
import {
  gluky_addressfield_gt_states_list,
  gluky_addressfield_gt_cities_list,
} from 'src/assets/utils/countryLocalities/gt-localities';
import {
  gluky_addressfield_ni_states_list,
  gluky_addressfield_ni_cities_list,
} from 'src/assets/utils/countryLocalities/ni-localities';
import {
  gluky_addressfield_pa_states_list,
  gluky_addressfield_pa_cities_list,
} from 'src/assets/utils/countryLocalities/pa-localities';
import {
  gluky_addressfield_es_states_list,
  gluky_addressfield_es_cities_list,
} from 'src/assets/utils/countryLocalities/es-localities';
import {
  gluky_addressfield_cr_states_list,
  gluky_addressfield_cr_cities_list,
} from 'src/assets/utils/countryLocalities/cr-localities';
import { environment } from 'src/environments/environment';
import { v4 as uuidv4 } from 'uuid';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-add-address',
  templateUrl: './add-address.page.html',
  styleUrls: ['./add-address.page.scss'],
})
export class AddAddressPage implements OnInit {
  edit = false;
  newAdressForm: FormGroup;
  fileCodesFunctions: any;
  fullAdress: any;
  states = [];
  cities = [];
  localities = [];
  country: string = environment.country;
  address: any;
  data: any;
  dataForm: any;
  validator: any;
  format_form: any;
  id_format: any;
  fromShoppingCart = false;
  statesStatus: boolean = false;
  contryName: string;

  constructor(
    public routerService: RouterService,
    public modalController: ModalController,
    private adressService: AdressService,
    private tagsService: TagsService,
    private alertController: AlertController,
    public languageService: LanguagesService,
    private storageService: StorageService,
    private formBuilder: FormBuilder,
    private route: ActivatedRoute
  ) {
    this.newAdressForm = this.formBuilder.group({});
    this.getInfoCountry();
  }

  ngOnInit() {
    this.getTextIUAddress();
    setTimeout(() => {
      for (let i in this.dataForm.countries) {
        console.log(this.dataForm.countries);
        if (this.dataForm.countries[i].indexOf(this.country) != -1) {
          this.id_format = i;
          this.format_form = this.dataForm.form_address[i];
        }
      }

      this.route.queryParams.subscribe((params) => {
        if (params.data) {
          this.fromShoppingCart = JSON.parse(params.data).fromShoppingCart;
        }
      });

      // this.fillPlaceHolders();
      this.generateForm();
      this.states = this.getStatesList();
      this.sortBy(this.states);
      this.tagsService.setEventTag('adress_page', 'adress_screen_viewed');
    }, 500);
  }

  async getInfoCountry() {
    const allCountry = {
      colombia: 'co',
      argentina: 'ar', // NO SE TIENE
      chile: 'cl',
      rica: 'cr',
      ecuador: 'ec',
      salvador: 'sv',
      guatemala: 'gu',
      honduras: 'hn',
      panama: 'pa',
      peru: 'pe',
      dominicana: 'do'
    };
    const { programs } = await this.storageService.get('gnx-claims');
    const data = programs[0].split('/').at(-1).split('_').at(-1);
    this.contryName = data;
    console.log(data);
    
    const country = allCountry[data];
    this.country = country;
    console.log("country ==", this.country);
    
  }

  sortBy(data: any) {
    data.sort(function (a, b) {
      var nameA = a.name.toUpperCase(); // ignore upper and lowercase
      var nameB = b.name.toUpperCase(); // ignore upper and lowercase
      if (nameA < nameB) {
        return -1;
      }
      if (nameA > nameB) {
        return 1;
      }

      // names must be equal
      return 0;
    });
  }

  generateForm() {
    this.format_form = Object.values(this.format_form);

    for (let field of this.format_form) {
      console.log(field.name);

      this.newAdressForm.addControl(
        field.name,
        new FormControl('', Validators.maxLength(field.maxlength))
      );

      if (field.required == true) {
        this.newAdressForm.controls[field.name].setValidators([
          Validators.required,
        ]);
      } else {
        this.newAdressForm.controls[field.name].clearValidators();
      }
      this.newAdressForm.controls[field.name].updateValueAndValidity();
    }
    //this.newAdressForm.patchValue(this.dataForm);
  }

  close() {
    this.modalController.dismiss('closeAddAdress');
  }

  getStatesList() {
    switch (this.country) {
      case 'pa':
        return gluky_addressfield_pa_states_list();
      case 'sv':
        return gluky_addressfield_es_states_list();
      case 'gu':
        return gluky_addressfield_gt_states_list();
      case 'hn':
        return gluky_addressfield_hn_states_list();
      case 'ni':
        return gluky_addressfield_ni_states_list();
      case 'cr':
        return gluky_addressfield_cr_states_list();
      case 'cl':
        return gluky_addressfield_cl_states_list();
      case 'co':
        return gluky_addressfield_co_states_list();
      case 'ec':
        return gluky_addressfield_ec_states_list();
      case 'do':
        return gluky_addressfield_rd_states_list();
      case 'mx':
        return gluky_addressfield_mx_states_list();
      case 'pe':
        return gluky_addressfield_per_states_list();
      case 'tt':
        return gluky_addressfield_tt_states_list();
      case 'jm':
        return gluky_addressfield_jm_states_list();
      case 'gy':
        return gluky_addressfield_gy_states_list();
      case 'aw':
        return gluky_addressfield_ar_states_list();
      case 'cw':
        return gluky_addressfield_cu_states_list();
      case 'bb':
        return gluky_addressfield_bb_states_list();
      case 'lc':
        return gluky_addressfield_lc_states_list();
      case 'ky':
        return gluky_addressfield_ky_states_list();
      case 'pr':
        return gluky_addressfield_pr_states_list();
      default:
        return gluky_addressfield_co_states_list();
    }
  }

  getCitiesList(code) {
    switch (this.country) {
      case 'co':
        return gluky_addressfield_co_cities_list(code);
      case 'ec':
        return gluky_addressfield_ec_cities_list(code);
      case 'do':
        return gluky_addressfield_rd_cities_list(code);
      case 'mx':
        return gluky_addressfield_mx_cities_list(code);
      case 'pe':
        return gluky_addressfield_per_cities_list(code);
      case 'tt':
        return gluky_addressfield_tt_cities_list(code);
      case 'jm':
        return gluky_addressfield_jm_cities_list(code);
      case 'gy':
        return gluky_addressfield_gy_cities_list(code);
      case 'aw':
        return gluky_addressfield_ar_cities_list(code);
      case 'cw':
        return gluky_addressfield_cu_cities_list(code);
      case 'bb':
        return gluky_addressfield_bb_cities_list(code);
      case 'ky':
        return gluky_addressfield_ky_cities_list(code);
      case 'lc':
        return gluky_addressfield_lc_cities_list(code);
      case 'pr':
        return gluky_addressfield_pr_cities_list(code);
      case 'pa':
        return gluky_addressfield_pa_cities_list(code);
      case 'sv':
        return gluky_addressfield_es_cities_list(code);
      case 'gu':
        return gluky_addressfield_gt_cities_list(code);
      case 'hn':
        return gluky_addressfield_hn_cities_list(code);
      case 'ni':
        return gluky_addressfield_ni_cities_list(code);
      case 'cr':
        return gluky_addressfield_cr_cities_list(code);
      case 'cl':
        return gluky_addressfield_cl_cities_list(code);
      default:
        return gluky_addressfield_co_cities_list(code);
    }
  }

  getLocalitiesList(state, city) {
    switch (this.country) {
      case 'co':
        return gluky_addressfield_co_localities_list(state, city);
      case 'ec':
        return gluky_addressfield_ec_localities_list(state, city);
      case 'do':
        return gluky_addressfield_rd_localities_list(state, city);
      default:
        return gluky_addressfield_co_localities_list(state, city);
    }
  }
  // cambio en selects
  changeState(code: any, field: any) {
    if (field == 'adminArea1' && code !== undefined) {
      this.cities = this.getCitiesList(code);
      this.sortBy(this.cities);
    }
    //TODO depronto ver como mas validar si el campo es texto o select para no validar por país
    if (
      field == 'adminArea2' &&
      this.newAdressForm.value.hasOwnProperty('locality') &&
      code !== undefined &&
      this.country !== 'mx'
    ) {
      this.localities = this.getLocalitiesList(
        this.newAdressForm.value.adminArea1,
        code
      );
      this.sortBy(this.localities);
    }
  }

  toUpperCaseOne(str) {
    if (str.length === 0) return str;
    return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
  }

  async sendForm(newAddress) {
    if (newAddress.postalCode.length <= 0) {
      newAddress.postalCode = '000000';
    }
    console.log('newAddress', newAddress);
    if (!this.edit) {
      await this.adressService.setAdress(newAddress);
    } else {
      await this.adressService.removeAdress(newAddress);
    }
    await this.adressService.setActiveAdresss(newAddress);
    this.newAdressForm.reset();
    if (this.fromShoppingCart) {
      this.routerService.redirectRootWithdata('app/map/list', {
        fromShoppingCart: true,
      });
    } else {
      this.routerService.redirectRoot(`app/map/list`);
    }
  }

  async showAlertConfirmation() {
    const newAddress = {
      uid: uuidv4(),
      adminArea1: {
        name: this.getStatesList().filter(
          (state) => state.code === this.newAdressForm.value.adminArea1
        )[0].name,
        code: this.newAdressForm.value.adminArea1,
      },
      adminArea2: {
        name: this.getCitiesList(this.newAdressForm.value.adminArea1).filter(
          (citie) => citie.code === this.newAdressForm.value.adminArea2
        )[0].name,
        code: this.newAdressForm.value.adminArea2,
      },
      ...(this.id_format == 'format1' && {
        locality: {
          name: this.getLocalitiesList(
            this.newAdressForm.value.adminArea1,
            this.newAdressForm.value.adminArea2
          )[0].name,
          code: this.newAdressForm.value.locality
            ? this.newAdressForm.value.locality
            : this.newAdressForm.value.postalCode,
        },
      }),
      ...((this.id_format == 'format3' || this.id_format == 'format2') && {
        locality: {
          name: this.newAdressForm.value.locality,
          code: this.newAdressForm.value.locality
            ? this.newAdressForm.value.locality
            : this.newAdressForm.value.postalCode,
        },
      }),
      country: {
        code: this.country.toUpperCase(),
        name: this.toUpperCaseOne(this.contryName),
      },
      ...(this.newAdressForm.value.hasOwnProperty('postalCode') && {
        postalCode: this.newAdressForm.value.postalCode,
      }),
      ...(this.id_format == 'format1' && {
        addressLine1: `${this.newAdressForm.value.principalStreet}`,
        addressLine2: `${this.newAdressForm.value.infoExtra}`,
      }),
      ...(this.id_format == 'format3' && {
        addressLine1: `${this.newAdressForm.value.principalStreet},${this.newAdressForm.value.numExt}`,
        addressLine2: `${this.newAdressForm.value.street1} y ${this.newAdressForm.value.street2}`,
      }),
      ...(this.id_format == 'format2' && {
        addressLine1: `${this.newAdressForm.value.principalStreet}`,
        addressLine2: `${this.newAdressForm.value.numExt}`,
      }),
      name: this.newAdressForm.value.name,
      infoExtra: this.newAdressForm.value.infoExtra,
    };
    return new Promise(async (resolve) => {
      const alert = await this.alertController.create({
        message: `${this.languageService.textsIU.page_maps.address_added_1} ${newAddress.addressLine1}, ${this.languageService.textsIU.page_maps.address_added_2} ${newAddress.name} ${this.languageService.textsIU.page_maps.address_added_3}`,
        buttons: [
          {
            text: `${this.languageService.textsIU.page_maps.cancel_button}`,
            role: 'cancel',
            cssClass: 'secondary',
            handler: (_) => {},
          },
          {
            text: 'Ok',
            handler: async () => {
              this.sendForm(newAddress);
              resolve(true);
            },
          },
        ],
      });
      await alert.present();
    });
  }

  getTextIUAddress() {
    this.dataForm = this.languageService.textsIU.address_form;
  }

  modelChangeFn(e: any) {
    this.statesStatus = true;
  }
}
